<template>
  <auth-layout>
    <div class="c-auth-card c-login-card">
      <div class="c-auth-card__top">
        <form @submit.prevent="login" method="post">
          <div class="c-auth-card__head">
            <img src="~@/assets/img/logo.svg" class="logo" alt="Sber logo">
          </div>
          <div class="c-auth-card__body c-login-card__body">
            <form-control
              :placeholder="payload.username.placeholder"
              :error="payload.username.error"
              :short="payload.username.short"
              :type="payload.username.type"
              v-model="payload.username.value"
              @input="checkFields(payload.username, 'username')"
              required
              autofocus
            />
            <form-control
              :placeholder="payload.password.placeholder"
              :error="payload.password.error"
              :short="payload.password.short"
              :type="payload.password.type"
              :iconType="payload.password.iconType"
              :iconClick="togglePassword"
              v-model="payload.password.value"
              @input="checkFields(payload.password, 'password')"
              required
            />
          </div>
          <div class="c-auth-card__controlls c-login-card__controlls">
            <button type="submit" class="button button__bold" :disabled="!formSuccess">{{$t('ui.login')}}</button>
            <router-link to="/change_password" class="link link__ui">{{$t('ui.forgot_password')}}</router-link>
          </div>
        </form>
      </div>
      <div class="c-auth-card__bottom c-login-card__bottom">
        <p class="text"><span class="hide-sm-to-down">{{$t('ui.account_question')}} </span> <router-link to="/signup" class="link link__bold">{{$t('ui.register')}}</router-link></p>
      </div>
    </div>
  </auth-layout>
</template>
<script>
import AuthLayout from "@/layouts/AuthLayout";
import FormControl from "@/components/forms/FormControl";
import { AUTH_REQUEST } from "@/store/actions/auth.js";

export default {
  data() {
    return {
      formSuccess: false,
      payload: {
        username: {
          value: "",
          short: "",
          error: "",
          placeholder: "login.username",
          type: "text"
        },
        password: {
          value: "",
          short: "",
          error: "",
          placeholder: "login.password",
          type: "password",
          iconType: "password"
        }
      }
    };
  },
  components: {
    AuthLayout,
    FormControl
  },
  methods: {
    togglePassword(data) {
      if (data.click) {
        if (this.payload.password.type === "password") {
          this.payload.password.type = "text";
        } else {
          this.payload.password.type = "password";
        }
      }
    },
    checkFields() {
      if (
        this.payload.username.value.length > 2 &&
        this.payload.password.value.length > 2
      ) {
        this.formSuccess = true;
      } else {
        this.formSuccess = false;
      }
    },
    login() {
      let { username, password } = this.payload;
      username = username.value;
      password = password.value;
      this.formSuccess = false;
      this.$store
        .dispatch(AUTH_REQUEST, { username, password })
        .then(data => {
          this.$router.go("/");
        })
        .catch(() => {
          this.formSuccess = true;
        });
    }
  }
};
</script>
